/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { getImageSize } from '../../lib/utils';

import styles from '../../../styles/partials/avatar.module.scss';

const propTypes = {
    image: PropTypes.shape({ url: PropTypes.string }),
    size: PropTypes.oneOf(['small']),
    className: PropTypes.string,
    shouldLoad: PropTypes.bool,
};

const defaultProps = {
    image: null,
    size: 'small',
    className: null,
    shouldLoad: true,
};

const Avatar = ({ image, size, className, shouldLoad }) => {
    const imageAtSize = getImageSize(image, size);
    const { url = null } = imageAtSize || {};
    return (
        <span
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <span
                className={styles.shape}
                style={{
                    backgroundImage: shouldLoad ? `url("${url}")` : null,
                }}
            />
        </span>
    );
};

Avatar.propTypes = propTypes;
Avatar.defaultProps = defaultProps;

export default Avatar;
